import * as Yup from 'yup';
import { EDOZVOLA_WEB_ID_REGEX, messages } from 'app/config/constants';

export const casePublicAuthorityValidationSchema = Yup.object({
  publicAuthority: Yup.array()
    .of(
      Yup.object().shape({
        oib: Yup.string().required(messages.MANDATORY_FIELD),
        cityMunicipality: Yup.string().required(messages.MANDATORY_FIELD),
        community: Yup.string().required(messages.MANDATORY_FIELD),
        postalCode: Yup.string().required(messages.MANDATORY_FIELD),
        postName: Yup.string().required(messages.MANDATORY_FIELD),
        street: Yup.string().required(messages.MANDATORY_FIELD),
        idJpt: Yup.string().required(messages.MANDATORY_FIELD),
        email: Yup.string().notRequired(),
        contactNumber: Yup.string().notRequired(),
        houseNumber: Yup.string().notRequired(),
        relevantRegulation: Yup.string().required(messages.MANDATORY_FIELD),
      }),
    )
    .min(1, messages.MANDATORY_FIELD),
  issuedActs: Yup.array().of(
    Yup.object().shape({
      jptActivity: Yup.array().min(1, messages.MANDATORY_FIELD).required(messages.MANDATORY_FIELD),
      name: Yup.string().required(messages.MANDATORY_FIELD),
      classificationMark: Yup.string().required(messages.MANDATORY_FIELD),
      orderNumber: Yup.string().required(messages.MANDATORY_FIELD),
      dateOfIssuing: Yup.date().required(messages.MANDATORY_FIELD),
    }),
  ),
});

export const casePublicAuthorityCaseUuidToCopyFromSchema = Yup.object({
  caseUuidToCopyFrom: Yup.string().matches(EDOZVOLA_WEB_ID_REGEX, 'Unesena šifra predmeta je neispravna!'),
});

